export const APP_VERSION = '5.0.1';
